import React, { MouseEvent, useState } from "react";
import { NavLink } from "react-router-dom";
import styles from './menu.module.css';
import { clsx } from 'clsx';
import { SearchIcon, MyIcon, UserIcon, EventIcon } from "../icons"
import type { NavLinkProps, NavLinkRenderProps, } from "react-router-dom";
import { useSelector } from "react-redux";
import type { RootState } from "../../services/store";
import NeedProfile from "../need-profile/need-profile";
import { useGetMatchUnreadCountsQuery } from "../../services/store/api/matchApi";

const Menu = () => {
    const profile = useSelector((state: RootState) => state.user.profile);
    const [blockedSection, setBlockedSection] = useState<string | null>(null);
    const { data: matchUnreadCounts } = useGetMatchUnreadCountsQuery(undefined, {
        skip: profile?.status !== 'ACTIVE',
        pollingInterval: 60000,
        refetchOnFocus: true,
        refetchOnReconnect: true,
    });
    const myUnreadCount = matchUnreadCounts?.total ?? 0;

    const navLinkClass: NavLinkProps["className"] = (
        { isActive, isPending }: NavLinkRenderProps
    ) =>
        clsx(
            styles.menuDefault,
            {
                [styles.menuPending as string]: isPending,
                [styles.menuActive as string]: isActive && !isPending,
            }
        );

    const handleProtectedClick =
        (sectionTitle: string) => (e: MouseEvent<HTMLAnchorElement>) => {
            if (profile) return;
            e.preventDefault();
            setBlockedSection(sectionTitle);
        };

    return (
        <>
            <footer className={styles.footer}>
                <div className={styles.menu}>
                    <NavLink to="/events" className={navLinkClass}>
                        <EventIcon />
                        <span className={styles.title}>События</span>
                    </NavLink>
                    <NavLink to="/profiles" className={navLinkClass} onClick={handleProtectedClick("Поиск")}>
                        <SearchIcon />
                        <span className={styles.title}>Поиск</span>
                    </NavLink>
                    <NavLink to="/my" className={navLinkClass} onClick={handleProtectedClick("Свои")}>
                        <span className={styles.iconWrap}>
                            <MyIcon />
                            {myUnreadCount > 0 && (
                                <span className={styles.badge}>+{myUnreadCount}</span>
                            )}
                        </span>
                        <span className={styles.title}>Свои</span>
                    </NavLink>
                    <NavLink to="/options" className={navLinkClass} onClick={handleProtectedClick("Настройки")}>
                        <UserIcon />
                        <span className={styles.title}>Настройки</span>
                    </NavLink>
                </div>
            </footer>

            {blockedSection && (
                <NeedProfile
                    title={`${blockedSection}`}
                    onClose={() => setBlockedSection(null)}
                />
            )}
        </>
    );
}

export default Menu;
